export default {
    datasync: {
        nivel: "intermedio",
        cuando: ["Copiar grandes volúmenes entre tu red y AWS.", "Migraciones y sincronizaciones programadas.", "Copiar entre S3, EFS y FSx."],
        evita: ["Un solo archivo ocasional.", "Replicación continua de bases: DMS."],
        alt: [["transfer", "Si tus socios usan SFTP."], ["storagegw", "Acceso continuo con aspecto local."], ["snow", "Cuando la red no alcanza."]],
        cobro: "Por GB de datos copiados; el tráfico de red se cobra aparte si sale de AWS.",
        con: ["s3", "efs", "fsx", "storagegw"],
        quiz: { p: "¿Qué instala DataSync en tu red?", o: ["Un agente que lee tus datos", "Un antivirus", "Un navegador"], c: 0, e: "El agente transfiere los datos de forma cifrada y verificada." },
    },
    transfer: {
        nivel: "intermedio",
        cuando: ["Socios o sistemas que envían archivos por SFTP, FTPS o FTP.", "Guardar directamente en S3 o EFS.", "Reemplazar un servidor SFTP propio."],
        evita: ["Si puedes usar APIs o enlaces prefirmados de S3."],
        alt: [["datasync", "Copias programadas."], ["s3", "Acceso por API."]],
        cobro: "Por hora de cada protocolo habilitado y por GB transferido.",
        con: ["s3", "efs", "iam", "route53"],
        quiz: { p: "¿Dónde quedan los archivos que llegan por SFTP?", o: ["En S3 o EFS", "En un disco USB", "En el correo"], c: 0, e: "Transfer traduce el protocolo a objetos o archivos." },
    },
    snow: {
        nivel: "avanzado",
        cuando: ["Mover decenas de TB o PB cuando la red es lenta.", "Cómputo en lugares sin conexión.", "Migraciones masivas únicas."],
        evita: ["Volúmenes que la red resuelve en días: DataSync."],
        alt: [["datasync", "Por la red."], ["storagegw", "Acceso continuo."]],
        cobro: "Por servicio de cada job y por días extra con el dispositivo; el envío se cobra aparte.",
        con: ["s3", "datasync", "storagegw"],
        quiz: { p: "¿Para qué volúmenes conviene Snow Family?", o: ["Muy grandes, cuando la red tardaría demasiado", "Archivos pequeños", "Correo"], c: 0, e: "Se envía un dispositivo físico con los datos." },
    },
    mgn: {
        nivel: "avanzado",
        cuando: ["Llevar servidores físicos o virtuales a EC2 sin rediseñarlos.", "Corte con poco tiempo de caída.", "Muchas máquinas de una vez."],
        evita: ["Solo bases de datos: DMS.", "Aplicaciones que conviene reescribir."],
        alt: [["dms", "Bases de datos."], ["migrationhub", "Seguimiento de la migración."]],
        cobro: "Gratis por servidor durante el periodo de migración (hasta 90 días); se pagan los recursos de AWS usados.",
        con: ["ec2", "migrationhub", "vpc"],
        quiz: { p: "¿Qué se instala en el servidor de origen?", o: ["Un agente de replicación", "Un navegador", "Una base"], c: 0, e: "Replica los discos de forma continua." },
    },
    migrationhub: {
        nivel: "avanzado",
        cuando: ["Planificar una migración grande.", "Ver el avance de varias herramientas.", "Agrupar servidores en aplicaciones."],
        evita: ["Migraciones muy pequeñas."],
        alt: [["mgn", "La herramienta que mueve servidores."], ["dms", "La que mueve bases."]],
        cobro: "Sin costo; pagas las herramientas y recursos que uses.",
        con: ["mgn", "dms"],
        quiz: { p: "¿Qué ofrece Migration Hub?", o: ["Un tablero único del avance de la migración", "Discos más rápidos", "Descuentos"], c: 0, e: "Centraliza el seguimiento." },
    },
};
